import { useMemo } from "react";
import { usePageBootstrap } from "./useBootstrapList";
import { isLabRole, isWeighbridgeRole } from "../lib/dashboardRole";
import { purchaseNeedsWeightRecording } from "../lib/unloadingHelpers";

/** Pending counts per bottom-nav route (and total on Home). */
export function useMobileNavBadges(user, enabled = false) {
  const { data } = usePageBootstrap({
    path: "/dashboard/bootstrap",
    enabled: enabled && !!user,
    wsTypes: ["purchase", "lab", "stack", "gate_pass"],
  });

  return useMemo(() => {
    const empty = { home: 0, byPath: {} };
    if (!data || !user) return empty;

    if (isLabRole(user.role)) {
      const truck = data.truck_queue?.length ?? data.lab_pending?.length ?? 0;
      const composite = data.composite_pending_count ?? 0;
      const stack = data.stack_pending_count ?? 0;
      const home = truck + composite + stack;
      return {
        home,
        byPath: {
          "/": home,
          "/lab/truck": truck,
          "/lab/composite": composite,
          "/lab/plant": 0,
          "/lab/stacks": stack,
        },
      };
    }

    if (isWeighbridgeRole(user.role)) {
      const weightQueue = (data.weight_queue || []).filter(purchaseNeedsWeightRecording);
      const inward = weightQueue.length + (data.ready_to_start?.length || 0);
      const outward = data.outward_queue_count ?? 0;
      const home = inward + outward;
      return {
        home,
        byPath: {
          "/": home,
          "/weighbridge/inward": inward,
          "/weighbridge/outward": outward,
          "/weighbridge/register": 0,
        },
      };
    }

    return empty;
  }, [data, user]);
}
